// company routes
import baseRoute from '../CompaniesPage/route';

const route = (id = ':id') => `${baseRoute()}/${id}`;

export default route;
